export const MT_DECOMMISSION_REQUESTER = 'MT_DECOMMISSION_REQUESTER';
export const MT_DECOMMISSION_APPROVER = 'MT_DECOMMISSION_APPROVER';

export const ROLE_LABELS = {
    ST_FORM_FILLER: 'ST Form Filler',
    MT_FORM_FILLER: 'MT Form Filler',
    APPROVER: 'Approver',
    DEVOPS: 'DevOps',
    LICENSE_GENERATOR: 'License Generator',
    CAPACITY_READER: 'Capacity Reader',
    [MT_DECOMMISSION_REQUESTER]: 'MT Decommission Requester',
    [MT_DECOMMISSION_APPROVER]: 'MT Decommission Approver'
};

export function normalizeRoles(userRoles = []) {
    return (Array.isArray(userRoles) ? userRoles : []).map((r) => String(r).toUpperCase());
}

export function hasRole(userRoles, role) {
    return normalizeRoles(userRoles).includes(String(role).toUpperCase());
}

export function canAccessDecommissionTab(userRoles = []) {
    const roles = normalizeRoles(userRoles);
    return (
        roles.includes(MT_DECOMMISSION_REQUESTER) ||
        roles.includes(MT_DECOMMISSION_APPROVER) ||
        roles.includes('DEVOPS')
    );
}

export function canAccessDecommissionRequestSubTab(userRoles = []) {
    return hasRole(userRoles, MT_DECOMMISSION_REQUESTER);
}

export function canAccessDecommissionApprovalSubTab(userRoles = []) {
    return hasRole(userRoles, 'DEVOPS');
}

export function canAccessDecommissionSubApprovalSubTab(userRoles = []) {
    return hasRole(userRoles, MT_DECOMMISSION_APPROVER);
}

export function canSubApproveDecommission(userRoles = []) {
    return canAccessDecommissionSubApprovalSubTab(userRoles);
}

export function canExecuteDecommission(userRoles = []) {
    return canAccessDecommissionApprovalSubTab(userRoles);
}

export function canApproveDecommission(userRoles = []) {
    return canSubApproveDecommission(userRoles) || canExecuteDecommission(userRoles);
}

/** Completed button + tenant complete API — DevOps only. */
export function canCompleteDecommission(userRoles = []) {
    return canExecuteDecommission(userRoles);
}

export function getDefaultDecommissionSubTab(userRoles = []) {
    if (canAccessDecommissionRequestSubTab(userRoles)) return 'request';
    if (canAccessDecommissionSubApprovalSubTab(userRoles)) return 'subApproval';
    if (canAccessDecommissionApprovalSubTab(userRoles)) return 'approval';
    return 'request';
}

export function formatDecommissionSubmitterStatus(status) {
    if (!status) return 'Unknown';

    switch (String(status).toUpperCase()) {
        case 'PENDING_SUB_APPROVER':
        case 'PENDING_APPROVER':
            return 'Pending Sub-Approver';
        case 'PENDING_DEVOPS_APPROVAL':
            return 'Pending DevOps Approval';
        case 'IN_PROGRESS':
            return 'Decommissioning';
        case 'FAILED':
            return 'Decommission Failed';
        case 'DEPROVISIONED_MANUALLY':
            return 'Storage Decommission In Progress';
        case 'APPROVED':
            return 'Decommission Successful';
        case 'REJECTED':
            return 'Rejected';
        default:
            return String(status)
                .replace(/_/g, ' ')
                .toLowerCase()
                .replace(/\b\w/g, (c) => c.toUpperCase());
    }
}

export function getDecommissionSubmitterStatusColor(status) {
    const normalized = String(status || '').toUpperCase();

    if (normalized === 'FAILED' || normalized === 'REJECTED') {
        return 'negative';
    }
    if (normalized === 'APPROVED') {
        return 'positive';
    }
    if (
        normalized === 'PENDING_SUB_APPROVER' ||
        normalized === 'PENDING_APPROVER' ||
        normalized === 'PENDING_DEVOPS_APPROVAL' ||
        normalized === 'IN_PROGRESS' ||
        normalized === 'DEPROVISIONED_MANUALLY'
    ) {
        return 'warning';
    }
    return '';
}
